import { Theme } from "./symbols";

export const lightTheme: Theme = {
    name: 'light',
    properties: {
        '--background': '#f6f7f9',
        '--on-background': '#000'
    }
}